import { isMultiKind } from '../guards/isMultiKind';
import type { LDContext } from '../types/types';

/**
 * Get the name of a context with smart resolution.
 * For multi-kind contexts, can optionally window to a specific kind.
 * Falls back to firstName + lastName, then to key.
 *
 * @param context - The context to get the name of.
 * @param kind - Optional kind to window into for multi-kind contexts.
 * @returns The resolved name or key.
 */
export function getContextNameOrFirstLastOrKey(context: LDContext, kind?: string): string {
  let activeContext: LDContext = context;
  if (isMultiKind(activeContext) && kind) {
    activeContext = activeContext[kind] as LDContext;
  }

  if ('name' in activeContext && activeContext.name) {
    return String(activeContext.name);
  }

  if (
    'firstName' in activeContext &&
    'lastName' in activeContext &&
    activeContext.firstName &&
    activeContext.lastName
  ) {
    return `${activeContext.firstName} ${activeContext.lastName}`;
  }
  return String(activeContext.key);
}
